import React from 'react';
import PropTypes from 'prop-types';

export const Archive = ({ width, height, ...props }) => (
  <svg
    data-icon='archive'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m12 18 4-4-1.4-1.4-1.6 1.6V10h-2v4.2l-1.6-1.6L8 14l4 4ZM5 8v11h14V8H5Zm0 13c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V6.525c0-.233.038-.458.112-.675.075-.217.188-.417.338-.6L4.7 3.725c.183-.233.412-.413.688-.538C5.662 3.063 5.95 3 6.25 3h11.5c.3 0 .587.063.863.188.274.124.504.304.687.537l1.25 1.525c.15.183.262.383.337.6.075.217.113.442.113.675V19c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21H5Zm.4-15h13.2l-.85-1H6.25L5.4 6Z'
    />
  </svg>
);

Archive.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Archive.defaultProps = {
  width: 24,
  height: 24,
};
